// hooks
import { useEffect } from "react";
import { useStateOfPreserveFilters } from "./useStateOfPreserveFilters";

// utils
import _isEmpty from "lodash/isEmpty";

// types
import type { Store } from "@/stores";
import { IS_FROM_FARE_CALENDAR } from "@/constants/content.constants";
import { $sessionStorage } from "@tajawal/web-core-sdk-v2";

export function useRestorePreservedFilters(
  store: Store,
  isRoundTrip: boolean,
): void {
  const {
    isLoading,
    restorePreservedFilters,
    preservedFilters,
    isResourcedFetched,
    restoreAirlineFilters,
    restoreAirportFilters,
    restorePriceFilters,
    restoreBaggageFilters,
    restoreStopFilters,
    restoreTimeFilters,
    isOutbound,
  } = useStateOfPreserveFilters(store, isRoundTrip);

  useEffect(() => {
    const isFromFareCalendar =
      Boolean($sessionStorage.get(IS_FROM_FARE_CALENDAR)) === true;
    if (_isEmpty(preservedFilters) || !isFromFareCalendar || !isOutbound) {
      return;
    }

    restoreBaggageFilters();
    restoreStopFilters();
    restoreTimeFilters();

    if (!isLoading) {
      restoreAirlineFilters();
      restoreAirportFilters();
      restorePriceFilters();
    }
  }, [isLoading, restorePreservedFilters, isResourcedFetched]);
}
